import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./PhotoGallery.css";

function PhotoGallery() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    dotsClass: "slick-dots custom-dots",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const images = [
    {
      src: `${process.env.PUBLIC_URL}/deckWithGuysEnhanced.jpg`,
      alt: "Deck with Guys",
    },
    {
      src: `${process.env.PUBLIC_URL}/sunsetWineEnhanced.jpg`,
      alt: "Sunset Wine",
    },
    { src: `${process.env.PUBLIC_URL}/backdeckEnhanced.jpg`, alt: "Back Deck" },
    {
      src: `${process.env.PUBLIC_URL}/sunsetHammockEnhanced.jpg`,
      alt: "Sunset Hammock",
    },
    {
      src: `${process.env.PUBLIC_URL}/sunsetBayEnhanced.jpg`,
      alt: "Sunset Bay",
    },
    {
      src: `${process.env.PUBLIC_URL}/meAndDauphineWalkingOnBay.jpg`,
      alt: "Me and Dauphine Walking on Bay",
    },
    {
      src: `${process.env.PUBLIC_URL}/familyShot2Enhanced.jpg`,
      alt: "Family Shot 2",
    },
    {
      src: `${process.env.PUBLIC_URL}/sunsetFerryEnhanced.jpg`,
      alt: "Sunset Ferry",
    },
  ];

  return (
    <div className="gallery-container">
      <div className="gallery-slider-container">
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} className="gallery-slide">
              <img
                src={image.src}
                alt={image.alt}
                className="gallery-image"
                onError={(e) => {
                  console.error(`Failed to load image: ${image.src}`);
                  e.target.style.display = "none";
                }}
              />
              <div className="gallery-overlay" />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

// Custom arrow components
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", zIndex: 3 }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", zIndex: 3 }}
      onClick={onClick}
    />
  );
}

export default PhotoGallery;
